import { z } from "zod";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutRecRuleTasyOrientation.errors.";

const typeTasyOrientationSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "type_tasy_orientation" },
);

const sendWhenSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "send_when" },
);

export const ticketAutRecRuleTasyOrientationSchema = z.object({
  id: z.string().optional(),
  typeTasyOrientation: typeTasyOrientationSchema,
  sendWhen: sendWhenSchema,
  enable: z.boolean(),
});

export type TTicketAutRecRuleTasyOrientationForm = z.infer<
  typeof ticketAutRecRuleTasyOrientationSchema
>;
